import { Platform } from 'react-native';
import styled from 'styled-components/native';

export default styled.View`
  border-radius: 14px;
  overflow: hidden;
  width: ${Platform.OS === 'web' ? '300px' : '100%'};
  background-color: black;
`;
